export default __webpack_public_path__ + "static/logo-f47abbb691ee6882b8486aac580665c3.png";